import styles from "./styles.module.css";
type ViewCardProps = {
  title: string;
  value: string;
};
const ViewCard = ({ title, value }: ViewCardProps) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.titleContainer}>{title}</div>
      <div className={styles.inputContainer}>{value}</div>
    </div>
  );
};

export default ViewCard;
